<div class="grid-loader component">
  <firebird-web-loader></firebird-web-loader>
</div>
